import { messages } from './messages';
import { BillingPlanIds } from '../../../../../../enums/billing-plan-ids';

/**
 * @typedef {import('../../../../../../prop-types/intl-types').MessageDescriptor} MessageDescriptor
 */

/**
 * @typedef {object} BillingPlanDowngradeConfirmationModalContent
 * @property {MessageDescriptor} [bannerMessage] - Optional banner message to display.
 * @property {MessageDescriptor} primaryMessage - Main message for the downgrade confirmation.
 * @property {MessageDescriptor[]} featureMessages - List of feature messages affected by the downgrade.
 */

/**
 * @type {{[billingPlanId: string]: BillingPlanDowngradeConfirmationModalContent}}
 */
export const BillingPlanDowngradeConfirmationModalContentMap = {
  [BillingPlanIds.Free2025Q2]: {
    bannerMessage: messages.userRoleWarning,
    primaryMessage: messages.freeDowngradePrimaryText,
    featureMessages: [],
  },
  [BillingPlanIds.Starter2025Q2]: {
    bannerMessage: messages.userRoleWarning,
    primaryMessage: messages.downgradePrimaryText,
    featureMessages: [
      messages.userSeats,
      messages.unlimitedAutomationRules,
      messages.customTrackingPortal,
      messages.inventoryManagement,
      messages.advancedAnalytics,
    ],
  },
  [BillingPlanIds.Standard2025Q2]: {
    primaryMessage: messages.downgradePrimaryText,
    featureMessages: [
      messages.dedicatedAccountManager,
      messages.userSeats,
      messages.advancedInventoryManagement,
      messages.autoSplitShipments,
      messages.CubiscanIntegration,
      messages.ODBCIntegration,
    ],
  },
};
